var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___Rzhndl",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___Rzhndl",
  "Se": "ChannelAttachmentArea.module__upload___Rzhndl",
  "PO": "ChannelAttachmentArea.module__uploadContainer___Rzhndl",
  "il": "ChannelAttachmentArea.module__mediaContainer___Rzhndl",
  "BA": "ChannelAttachmentArea.module__clickableMedia___Rzhndl",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___Rzhndl",
  "R": "ChannelAttachmentArea.module__hidden___Rzhndl",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___Rzhndl",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___Rzhndl",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___Rzhndl",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___Rzhndl",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___Rzhndl",
  "p6": "ChannelAttachmentArea.module__spoiler___Rzhndl",
  "$_": "ChannelAttachmentArea.module__media___Rzhndl",
  "_A": "ChannelAttachmentArea.module__tags___Rzhndl",
  "H6": "ChannelAttachmentArea.module__filenameContainer___Rzhndl",
  "iW": "ChannelAttachmentArea.module__filename___Rzhndl",
  "VF": "ChannelAttachmentArea.module__fileDetails___Rzhndl",
  "Ov": "ChannelAttachmentArea.module__fileSize___Rzhndl",
  "i_": "ChannelAttachmentArea.module__fileExtension___Rzhndl",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___Rzhndl",
  "KY": "ChannelAttachmentArea.module__actionBar___Rzhndl" + " " + __webpack_require__(77126)["KE"],
  "x6": "ChannelAttachmentArea.module__button___Rzhndl" + " " + __webpack_require__(77126)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___Rzhndl",
  "le": "ChannelAttachmentArea.module__actionBarIcon___Rzhndl",
  "s3": "ChannelAttachmentArea.module__altTag___Rzhndl",
  "Kk": "ChannelAttachmentArea.module__icon___Rzhndl",
  "Dp": "ChannelAttachmentArea.module__iconImage___Rzhndl",
  "vt": "ChannelAttachmentArea.module__videoModal___Rzhndl",
  "j": "ChannelAttachmentArea.module__videoContainer___Rzhndl",
  "yF": "ChannelAttachmentArea.module__divider___Rzhndl",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___Rzhndl",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___Rzhndl",
};

module.exports = exports;
